import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function ProductReveal() {
  return <section className="py-24 md:py-32 bg-brown-900 text-cream-50 relative overflow-hidden" data-id="element-296">
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-297"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-298">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-299">
          <FadeIn data-id="element-300">
            <div className="relative" data-id="element-301">
              <span className="text-terracotta font-medium tracking-widest text-sm uppercase mb-4 block" data-id="element-302">
                La Solución Definitiva
              </span>
              <h2 className="text-4xl md:text-6xl font-serif mb-6 leading-tight" data-id="element-303">
                Presentando: <br data-id="element-304" />
                <span className="text-terracotta italic" data-id="element-305">
                  El Diccionario del Cabello
                </span>
              </h2>
              <p className="text-xl md:text-2xl text-cream-200 font-light mb-8 leading-relaxed" data-id="element-306">
                Una guía maestra en español para mujeres que quieren resultados
                reales sin vivir en el baño.
              </p>

              <div className="space-y-4" data-id="element-307">
                {['Secciones por tipo de cabello: liso, ondulado, rizado, afro', 'Rutinas diarias (mañana + noche) que caben en la vida real', 'Lavado, hidratación, definición, refresh y peinados rápidos', 'Mascarillas caseras con ingredientes naturales', 'Productos recomendados fáciles de conseguir', 'El Kit Mínimo mixed (barato vs mejor) con pros y contras'].map((feature, i) => <div key={i} className="flex items-start gap-4" data-id="element-308">
                    <div className="w-6 h-6 rounded-full bg-olive/20 flex items-center justify-center shrink-0 mt-1" data-id="element-309">
                      <Check className="w-4 h-4 text-olive-light" data-id="element-310" />
                    </div>
                    <span className="text-cream-100/90 text-lg" data-id="element-311">{feature}</span>
                  </div>)}
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} className="relative flex justify-center lg:justify-end" data-id="element-312">
            {/* Abstract Book/PDF Representation */}
            <div className="relative w-[300px] md:w-[400px] aspect-[3/4] bg-cream-50 rounded-r-2xl rounded-l-sm shadow-2xl transform rotate-[-3deg] hover:rotate-0 transition-transform duration-500" data-id="element-313">
              <div className="absolute inset-0 bg-gradient-to-br from-white to-cream-100 rounded-r-2xl rounded-l-sm border-l-8 border-brown-800 overflow-hidden flex flex-col" data-id="element-314">
                <div className="p-8 flex-1 flex flex-col items-center justify-center text-center border-r border-b border-black/5" data-id="element-315">
                  <div className="w-full h-full border-2 border-brown-900/10 p-6 flex flex-col items-center justify-center" data-id="element-316">
                    <span className="text-xs tracking-[0.3em] text-brown-800/60 uppercase mb-8" data-id="element-317">
                      Guía Oficial
                    </span>
                    <h3 className="text-4xl md:text-5xl font-serif text-brown-900 leading-none mb-2" data-id="element-318">
                      El <br data-id="element-319" />
                      Diccionario
                    </h3>
                    <h3 className="text-4xl md:text-5xl font-serif text-terracotta italic leading-none mb-12" data-id="element-320">
                      del Cabello
                    </h3>
                    <div className="w-12 h-1 bg-brown-900/20 mb-8" data-id="element-321"></div>
                    <p className="text-sm text-brown-800/60 font-medium" data-id="element-322">
                      EDICIÓN EN ESPAÑOL
                    </p>
                  </div>
                </div>
              </div>
              {/* Pages effect */}
              <div className="absolute top-2 right-[-10px] w-[10px] h-[98%] bg-cream-200 rounded-r-sm shadow-lg z-[-1]" data-id="element-323"></div>
              <div className="absolute top-3 right-[-18px] w-[10px] h-[96%] bg-cream-100 rounded-r-sm shadow-lg z-[-2]" data-id="element-324"></div>
            </div>

            {/* Decorative circle behind */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-terracotta/20 rounded-full blur-[80px] z-[-10]" data-id="element-325"></div>
          </FadeIn>
        </div>
      </div>
    </section>;
}